<template>
  <div>
  <div class="overlay"></div>

  <div class="modal_fixed">
    <div class="new_achievement_box locked_achievement modal_cont" id="achievement_locked_modal">
      <img src="static/images/store/icon-close-back-popup.svg" class="btn_close" @click="$emit('close')">
      <h1>{{ getTranslations.home_modals_achievements_title }} {{ achievementInfo.achievementLevelName }}</h1>
      <p>{{ getTranslations.home_modals_achievements_play }} {{ achievementInfo.threshold }} {{ getTranslations.home_modals_achievements_locked_questions }} "{{ achievementInfo.achievementLevelName }}"</p>
      <div class="modal_locked_achievement">
        <img src="static/images/achievements/icon-Achievement-L.png" class="icon_achievement">
        <img class="lockedicon" src="static/images/lock_icon.svg">
      </div>
      <h2>{{ getTranslations.home_modals_achievements_rewarded}}</h2>
      <achievement-reward :achievement-info="achievementInfo" :disable-play="true"/>

      <div class="icons_achievement_row">
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AchievementReward from '@/components/home/modals/achievements/AchievementReward';

export default {
  name: 'achievement-locked',
  components: {
    AchievementReward,
  },
  props: {
    achievementInfo: Object,
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/achievements/AchievementLocked.vue